import { Button, mergeClasses } from '@fluentui/react-components';
import { useIsDarkMode } from '@office-start/theming-service';
import React from 'react';
import baseStyles from '../CommonAppHostControlStyles.module.scss';
import styles from './AppHostErrorControl.module.scss';
import { ErrorCatDarkIcon, ErrorCatLightIcon } from './AppHostErrorIcons';
export var AppHostErrorControl = function (_a) {
    var correlationId = _a.correlationId, refreshCallBack = _a.refreshCallBack, errorStrings = _a.errorStrings;
    var isDarkMode = useIsDarkMode();
    var themeClassSuffix = isDarkMode ? 'dark' : 'default';
    return (React.createElement("div", { className: baseStyles['container'], style: { textAlign: 'center' } },
        isDarkMode ? (React.createElement(ErrorCatDarkIcon, { width: "280", height: "280", viewBox: "0 0 280 280" })) : (React.createElement(ErrorCatLightIcon, { width: "280", height: "280", viewBox: "0 0 280 280" })),
        React.createElement("div", { className: mergeClasses(styles['text-container'], baseStyles['container-no-grow']) },
            React.createElement("span", { className: styles["error-header-text".concat(themeClassSuffix)] }, errorStrings.errorUiHeaderText),
            React.createElement("span", { className: styles["error-secondary-text".concat(themeClassSuffix)] }, errorStrings.errorUiSecondaryText),
            React.createElement("span", { className: styles["error-secondary-text".concat(themeClassSuffix)] },
                errorStrings.correlationIdLabel,
                " ",
                correlationId)),
        React.createElement(Button, { appearance: "primary", onClick: refreshCallBack, size: "medium" }, errorStrings.retryButtonText)));
};
//# sourceMappingURL=AppHostErrorControl.js.map